import React from 'react';
import { createComponent } from '@lit/react';
import { IxListItem as LitComp } from '../IxListItem.js';

customElements.define('ix-list-item', LitComp);

export const IxListItem = createComponent({
  tagName: 'ix-list-item-react',
  elementClass: LitComp,
  react: React,
});
